import { RouteConfig } from 'vue-router';
import Home from '@/views/Home/index.vue';

const menuRoutes: Array<RouteConfig> = [
  {
    path: '/question',
    name: 'question',
    meta: {
      name: '题库管理',
      icon: 'question-circle',
      auth: true,
    },
    component: Home,
    redirect: '/',
    children: [
      {
        path: '/question/exercises',
        name: 'exercises',
        meta: {
          name: '课上练习题',
          icon: 'th',
          tag: true,
          menu: true,
        },
        component: () => import('@/views/Home/layout/question/index.vue'),
      },
      {
        path: '/question/homeWork',
        name: 'homework',
        meta: {
          name: '扩展题',
          icon: 'th',
          tag: true,
          menu: true,
        },
        component: () => import('@/views/Home/layout/question/homeWork/index.vue'),
      },
    ],
  },
  {
    path: '/asset',
    name: 'asset',
    meta: {
      name: '素材管理',
      icon: 'photo',
      auth: true,
    },
    component: Home,
    redirect: '/',
    children: [
      {
        path: '/asset/manage',
        name: 'manage',
        meta: {
          name: '素材库',
          icon: 'th',
          tag: true,
          menu: true,
        },
        component: () => import('@/views/Home/layout/asset/manage/index.vue'),
      },
      {
        path: '/asset/public',
        name: 'public',
        meta: {
          name: '公共素材',
          icon: 'reorder',
          tag: true,
          menu: true,
        },
        component: () => import('@/views/Home/layout/asset/public/index.vue'),
      },
    ],
  },
  {
    path: '/course',
    name: 'course',
    meta: {
      name: '课程管理',
      icon: 'calculator',
      auth: true,
    },
    component: Home,
    redirect: '/',
    children: [
      {
        path: '/course/info',
        name: 'info',
        meta: {
          name: '正式课管理',
          icon: 'reorder',
          tag: true,
          menu: true,
        },
        component: () => import('@/views/Home/layout/course/info/index.vue'),
      },
      {
        path: '/course/trial',
        name: 'trial',
        meta: {
          name: '试听课管理',
          icon: 'th',
          tag: true,
          menu: true,
        },
        component: () => import('@/views/Home/layout/course/trial/index.vue'),
      },
      {
        path: '/course/type',
        name: 'type',
        meta: {
          name: '课程分类',
          icon: 'th',
          tag: true,
          menu: true,
        },
        component: () => import('@/views/Home/layout/course/type/index.vue'),
      },
    ],
  },
  {
    path: '/set',
    name: 'set',
    meta: {
      name: '系统配置',
      icon: 'cog',
      auth: true,
    },
    component: Home,
    redirect: '/',
    children: [
      {
        path: '/set/base',
        name: 'base',
        meta: {
          name: '系统设置',
          icon: 'th',
          tag: true,
          menu: true,
        },
        component: () => import('@/views/Home/layout/set/base/index.vue'),
      },
      {
        path: '/set/normal',
        name: 'base',
        meta: {
          name: '字典配置',
          icon: 'th',
          tag: true,
          menu: true,
        },
        component: () => import('@/views/Home/layout/set/normal/index.vue'),
      },
      {
        path: '/set/poster',
        name: 'poster',
        meta: {
          name: '海报管理',
          icon: 'th',
          tag: true,
          menu: true,
        },
        component: () => import('@/views/Home/layout/set/poster/index.vue'),
      },
      {
        path: '/set/courseHours',
        name: 'courseHours',
        meta: {
          name: '课时配置',
          icon: 'th',
          tag: true,
          menu: true,
        },
        component: () => import('@/views/Home/layout/set/course/index.vue'),
      },
      {
        path: '/set/uploadApp',
        name: 'uploadApp',
        meta: {
          name: '软件配置',
          icon: 'th',
          tag: true,
          menu: true,
        },
        component: () => import('@/views/Home/layout/set/uploadApp/index.vue'),
      },
      {
        path: '/set/activityBanner',
        name: 'activityBanner',
        meta: {
          name: '活动海报',
          icon: 'th',
          tag: true,
          menu: true,
        },
        component: () => import('@/views/Home/layout/set/activityBanner/index.vue'),
      },
    ],
  },
  {
    path: '/achievement',
    name: 'achievement',
    meta: {
      name: '成就管理',
      icon: 'calculator',
      autor: true,
    },
    component: Home,
    redirect: '/',
    children: [
      {
        path: '/achievement/manage',
        name: 'works',
        meta: {
          name: '成就',
          icon: 'th',
          tag: true,
          menu: true,
        },
        component: () => import('@/views/Home/layout/achievement/manage/index.vue'),
      },
      {
        path: '/achievement/type',
        name: 'works',
        meta: {
          name: '类别',
          icon: 'th',
          tag: true,
          menu: true,
        },
        component: () => import('@/views/Home/layout/achievement/manage/index.vue'),
      },
    ],
  },
  {
    path: '/verify',
    name: 'verify',
    meta: {
      name: '审核管理',
      icon: 'pencil-square-o',
      auth: true,
    },
    component: Home,
    redirect: '/',
    children: [
      {
        path: '/verify/works',
        name: 'works',
        meta: {
          name: '作品审核',
          icon: 'th',
          tag: true,
          menu: true,
        },
        component: () => import('@/views/Home/layout/verify/works/index.vue'),
      },
    ],
  },
  {
    path: '/content',
    name: 'content',
    meta: {
      name: '内容管理',
      icon: 'file-text',
      auth: true,
    },
    component: Home,
    redirect: '/',
    children: [
      {
        path: '/content/sensitive',
        name: 'sensitive',
        meta: {
          name: '敏感词管理',
          icon: 'map',
          tag: true,
          menu: true,
        },
        component: () => import('@/views/Home/layout/content/sensitive/index.vue'),
      },
    ],
  },
  {
    path: '/exams',
    name: 'exams',
    meta: {
      name: '考试管理',
      icon: 'life-ring',
      auth: true,
    },
    component: Home,
    redirect: '/',
    children: [
      {
        path: '/exams/wor',
        name: 'wor',
        meta: {
          name: '试题管理',
          icon: 'map',
          tag: true,
          menu: true,
        },
        component: () => import('@/views/Home/layout/exams/wor/index.vue'),
      },
      {
        path: '/exams/questions',
        name: 'questions',
        meta: {
          name: '题库管理',
          icon: 'copy',
          tag: true,
          menu: true,
        },
        component: () => import('@/views/Home/layout/exams/questions/index.vue'),
      },
      {
        path: '/exams/paper',
        name: 'paper',
        meta: {
          name: '试卷管理',
          icon: 'ticket',
          tag: true,
          menu: true,
        },
        component: () => import('@/views/Home/layout/exams/paper/index.vue'),
      },
      {
        path: '/exams/exam',
        name: 'exam',
        meta: {
          name: '公开考试',
          icon: 'map',
          tag: true,
          menu: true,
        },
        component: () => import('@/views/Home/layout/exams/exam/index.vue'),
      },
    ],
  },
];

const stairRoutes: Array<RouteConfig> = [
  {
    path: '/org',
    name: 'org',
    meta: {
      name: '机构管理',
      icon: 'sitemap',
      tag: true,
      stair: true,
      menu: true,
    },
    component: () => import('@/views/Home/layout/org/manage/index.vue'),
  },
  {
    path: '/ipReport',
    name: 'ipReport',
    meta: {
      name: 'IP地址统计',
      icon: 'address-card-o',
      tag: true,
      stair: true,
      menu: true,
    },
    component: () => import('@/views/Home/layout/ipReport/index.vue'),
  },
  {
    path: '/match',
    name: 'match',
    meta: {
      name: '赛事管理',
      icon: 'trophy',
      tag: true,
      stair: true,
      menu: true,
    },
    component: () => import('@/views/Home/layout/match/manage/index.vue'),
  },
  {
    path: '/module',
    name: 'module',
    meta: {
      name: '模块管理',
      icon: 'modx',
      tag: true,
      stair: true,
      menu: true,
    },
    component: () => import('@/views/Home/layout/module/index.vue'),
  },
  {
    path: '/helpQues',
    name: 'helpQues',
    meta: {
      name: '帮助问题',
      icon: 'calculator',
      tag: true,
      stair: true,
      menu: true,
    },
    component: () => import('@/views/Home/layout/helpQues/index.vue'),
  },
  {
    path: '/userManage',
    name: 'userManage',
    meta: {
      name: '用户管理',
      icon: 'user',
      tag: true,
      stair: true,
      menu: true,
    },
    component: () => import('@/views/Home/layout/userManage/index.vue'),
  },
  {
    path: '/videoManage',
    name: 'videoManage',
    meta: {
      name: '视频管理',
      icon: 'video-camera',
      tag: true,
      stair: true,
      menu: true,
    },
    component: () => import('@/views/Home/layout/videoManagement/index.vue'),
  },
];

export default [...stairRoutes, ...menuRoutes];
